module.exports = __webpack_public_path__ + "img/sipky-1.b7511184.png";